export default __webpack_public_path__ + "bcbf28f67a1bfe08d4e2f1369a214913.svg";